import * as React from "react";

import { useGtm } from "../../../Common";

import { ReactMyBagAnalyticsInterface } from "./analytics-interface";

export const useAnalyticsGtm = () => {
  const { pushToTheDataLayer, consumerInitializationGuard } = useGtm();

  const removeFromCartAction: NonNullable<
    ReactMyBagAnalyticsInterface["removeFromCartAction"]
  > = React.useCallback(
    ({ productId }) => {
      let event = {
        event: "remove-from-cart",
        target: {
          product: `${productId}`,
        },
      };

      pushToTheDataLayer(event);
    },
    [pushToTheDataLayer]
  );

  const initializedInterface: ReactMyBagAnalyticsInterface = React.useMemo(
    () => ({
      hasInitialized: true,
      removeFromCartAction,
    }),
    [removeFromCartAction]
  );
  const analyticsInterface = consumerInitializationGuard({
    initializedInterface,
  });
  return analyticsInterface;
};
